const middleware = {}

middleware['headers'] = require('../src/middleware/headers.ts')
middleware['headers'] = middleware['headers'].default || middleware['headers']

middleware['shared-collection'] = require('../src/middleware/shared-collection.ts')
middleware['shared-collection'] = middleware['shared-collection'].default || middleware['shared-collection']

middleware['terms-of-service'] = require('../src/middleware/terms-of-service.ts')
middleware['terms-of-service'] = middleware['terms-of-service'].default || middleware['terms-of-service']

export default middleware
